<mat-drawer-container autosize class="flex flex-col justify-between items-start md:flex-row md:justify-start flex-auto">
    <mat-drawer
        #drawer
        [mode]="enableLayoutMobile() ? 'over' : 'side'"
        [opened]="!enableLayoutMobile()"
        [class.is-not-mobile]="!enableLayoutMobile()"
    >
        <div class="menu flex flex-col bg-kiwid-surface fixed bottom-0 left-0 xs:w-full sm:w-full z-10 overflow-auto items-start justify-start">
            <div class="flex flex-col">
                <div class="flex flex-row items-start justify-between">
                    <a class="flex flex-row" [routerLink]="backRouterLink()" [queryParams]="backRouterQueryParam()">
                        <k-button iconAlign="left" materialIcon="keyboard_arrow_left" type="transparent">
                            {{ 'ORDER_DETAIL.MENU.BACK' | translate }}
                        </k-button>
                    </a>

                    @if (enableLayoutMobile()) {
                        <a (click)="toggleSidebar()">
                            <k-button [onlyIcon]="true" materialIcon="close" type="transparent-dark" />
                        </a>
                    }
                </div>
                <div class="flex flex-col my-2 px-6">
                    <div class="flex flex-row items-center justify-start font-medium text-[18px] text-neutral-darker">
                        @if (!isLoading()) {
                            {{ order()?.table.number }}
                            @if (!!order().remakeType) {
                                <div
                                    class="label-remake ml-2"
                                    ngxTippy
                                    [tippyProps]="{
                                    theme: 'kiwid',
                                    allowHTML: true,
                                    placement: 'right',
                                    maxWidth: 280,
                                    content: order()?.table?.remakeTooltip,
                                }"
                                >
                                    {{ order()?.table?.remakeLabel }}
                                </div>
                            }

                            @if (order().isPriority) {
                                <mat-icon class="ml-2 text-ui-error-default size-18">flag</mat-icon>
                            }
                        } @else {
                            <ngx-skeleton-loader [theme]="{ 'width.px': 120, 'height.px': 25 }" />
                        }
                    </div>
                    <span class="font-typography-text-medium text-neutral-lighter">{{ 'ORDER_DETAIL.MENU.DETAIL' | translate }}</span>
                </div>

                @if (order()?.table.isShowApproval) {
                    <div
                        class="flex flex-row justify-between items-center bg-ui-warning-lighter dark:bg-ui-warning-light py-3 px-6 text-ui-warning-darkest font-medium text-[13px] line-height-1.25 gap-2 mt-1"
                    >
                        {{ 'ORDER_DETAIL.MENU.APPROVAL_DESCRIPTION' | translate }}
                        <k-button [loading]="isLoadingApproval()" (click)="sendApproval()">
                            {{ 'ORDER_DETAIL.MENU.APPROVE' | translate }}
                        </k-button>
                    </div>
                }

                <div class="flex flex-col border-y-[1px] border-kiwid-divider p-6 gap-6">
                    <div class="flex flex-col items-start justify-start gap-1">
                    <span class="font-typography-text-small-label text-neutral-default m-0">
                        {{ 'ORDER_DETAIL.MENU.STATUS' | translate }}
                    </span>
                        @if (!isLoading()) {
                            <k-label
                                [materialIcon]="order()?.table?.status.icon"
                                [type]="order()?.table?.status.type"
                            >
                                {{ order()?.table?.status.text }}
                            </k-label>
                        } @else {
                            <ngx-skeleton-loader [theme]="{ 'width.px': 73, 'height.px': 20, 'border-radius.px': 20 }" />
                        }
                    </div>

                    <div class="flex flex-col items-start justify-start gap-1">
                    <span class="font-typography-text-small-label text-neutral-default m-0">
                        {{ 'ORDER_DETAIL.MENU.LABORATORY' | translate }}
                    </span>
                        <div class="flex flex-row items-center justify-start">
                            @if (!isLoading()) {
                                <ngx-avatars
                                    [initialsSize]="2"
                                    [name]="order()?.table?.laboratory?.name"
                                    [src]="order()?.table?.laboratory?.logo"
                                    [size]="24"
                                    [round]="false"
                                    [cornerRadius]="4"
                                />
                                <span class="font-bold text-[13px] text-brand-main-darker ml-2 uppercase">{{ order()?.table?.laboratory?.name }}</span>
                            } @else {
                                <ngx-skeleton-loader [theme]="{ 'width.px': 24, 'height.px': 24, 'border-radius.px': 4 }" />
                                <ngx-skeleton-loader class="ml-2" [theme]="{ 'width.px': 129, 'height.px': 20 }" />
                            }
                        </div>
                    </div>

                    @if (!!order()?.table?.customerUser) {
                        <div class="flex flex-col items-start justify-start gap-1">
                        <span class="font-typography-text-small-label text-neutral-default m-0">
                            {{ 'ORDER_DETAIL.MENU.CUSTOMER_USER' | translate }}
                        </span>
                            <div class="flex flex-row items-center justify-start">
                                @if (!isLoading()) {
                                    <ngx-avatars
                                        [name]="order()?.table?.customerUser?.name"
                                        [src]="order()?.table?.customerUser?.avatar"
                                        [size]="24"
                                        [round]="false"
                                        [cornerRadius]="12"
                                    />
                                    <span class="font-bold text-[13px] text-brand-main-darker ml-2 uppercase">{{
                                            order()?.table?.customerUser?.name
                                        }}</span>
                                } @else {
                                    <ngx-skeleton-loader [theme]="{ 'width.px': 24, 'height.px': 24, 'border-radius.px': 12 }" />
                                    <ngx-skeleton-loader class="ml-2" [theme]="{ 'width.px': 129, 'height.px': 20 }" />
                                }
                            </div>
                        </div>
                    }

                    <div class="flex flex-col items-start justify-start gap-1 w-full">
                    <span class="font-typography-text-small-label text-neutral-default m-0">
                        {{ 'ORDER_DETAIL.MENU.PATIENT' | translate }}
                    </span>
                        <div class="flex flex-row w-full">
                            @if (!isLoading()) {
                                <div class="flex flex-row items-center justify-between w-full" [class.justify-start]="!order()?.table?.enableEditPatient">
                                    <span class="font-bold text-[13px] text-brand-main-darker">{{ order()?.table?.patient ?? '-' }}</span>
                                    @if (order()?.table?.enableEditPatient) {
                                        <k-button
                                            type="transparent-neutral-default"
                                            [onlyIcon]="true"
                                            padding="false"
                                            buttonWidth="20px"
                                            buttonHeight="20px"
                                            iconSize="size-20"
                                            svgMaterialIcon="kiwid:edit"
                                            class="ic-settings"
                                            (click)="getPatient(true)"
                                            [matMenuTriggerFor]="matMenuPatient"
                                            [loading]="isLoadingSetPatient()"
                                            [style.pointer-events]="isLoadingSetPatient() ? 'none' : 'auto'"
                                        />
                                    }
                                </div>
                            } @else {
                                <ngx-skeleton-loader [theme]="{ 'width.px': 120, 'height.px': 18 }" />
                            }
                        </div>
                    </div>

                    <!-- TODO: PRIOLO - Recebido por
                    <div class="flex flex-col items-start justify-start gap-1">
                    <span class="font-typography-text-small-label text-neutral-default m-0">
                        {{ 'ORDER_DETAIL.MENU.RECEIVER' | translate }}
                    </span>
                        <div class="flex flex-row items-center justify-start">
                            @if (!isLoading()) {
                                <span class="font-medium text-[13px] text-neutral-dark">Marcus Adolfi</span>
                            } @else {
                                <ngx-skeleton-loader [theme]="{ 'width.px': 120, 'height.px': 18 }" />
                            }
                        </div>
                    </div>
                    -->
                </div>

                @if (isLoading() || !!order()?.table?.orderDate || !!order()?.table?.expectedDate) {
                    <div class="flex flex-col border-b-[1px] border-kiwid-divider p-6 gap-6">
                        @if (!!order()?.table?.orderDate) {
                            <div class="flex flex-col items-start justify-start gap-1">
                            <span class="font-typography-text-small-label text-neutral-default m-0">
                                {{ 'ORDER_DETAIL.MENU.CREATED_AT' | translate }}
                            </span>
                                @if (!isLoading()) {
                                    <span class="font-medium text-[13px] text-neutral-dark">{{ order()?.table?.orderDate }}</span>
                                } @else {
                                    <ngx-skeleton-loader [theme]="{ 'width.px': 128, 'height.px': 18 }" />
                                }
                            </div>
                        }

                        @if (!!order()?.table?.expectedDate) {
                            <div class="flex flex-col items-start justify-start gap-1">
                            <span class="font-typography-text-small-label text-neutral-default m-0">
                                {{ 'ORDER_DETAIL.MENU.EXPECTED_DATE' | translate }}
                            </span>
                                @if (!isLoading()) {
                                    <span class="flex flex-row items-center justify-start font-medium text-[13px] text-neutral-dark gap-1">
                                    {{ order()?.table?.expectedDate }}

                                        @if (order()?.table?.isDeliveryConfirmed) {
                                            <mat-icon
                                                class="size-18 text-ui-success-default font-bold"
                                                svgIcon="mat_solid:check_circle"
                                                ngxTippy
                                                [tippyProps]="{
                                                theme: 'kiwid',
                                                allowHTML: true,
                                                placement: 'right',
                                                maxWidth: 280,
                                                content: order()?.table?.isDeliveryConfirmed?.text,
                                            }"
                                            />
                                        }
                                </span>
                                } @else {
                                    <ngx-skeleton-loader [theme]="{ 'width.px': 128, 'height.px': 18 }" />
                                }
                            </div>
                        }
                    </div>
                }

                @if (isLoading() || !!order()?.table?.address) {
                    <div class="flex flex-col border-b-[1px] border-kiwid-divider p-6 gap-1">
                        <span class="font-typography-title-small text-brand-main-dark">{{ 'ORDER_DETAIL.MENU.ADDRESS' | translate }}</span>

                        @if (!isLoading()) {
                            <div class="flex flex-col text-neutral-default text-[13px] font-medium">
                                <span class="text-neutral-dark">{{ order()?.table?.address.firstLineAddress }}</span>
                                @if (!!order()?.table?.address.secondLineAddress) {
                                    <span>{{ order()?.table?.address.secondLineAddress }}</span>
                                }
                                @if (!!order()?.table?.address.thirdLineAddress) {
                                    <span>{{ order()?.table?.address.thirdLineAddress }}</span>
                                }
                            </div>
                        } @else {
                            <ngx-skeleton-loader class="flex flex-col gap-1" [count]="3" [theme]="{ 'width.px': 220, 'height.px': 18 }" />
                        }
                    </div>
                }

                @let deliveryRoute = order()?.table?.deliveryRoute;

                @if (isLoading() || !!deliveryRoute) {
                    <hr class="m-0 border-none h-[1px] bg-kiwid-divider" />
                    <div class="flex flex-col items-start menu-container section-slider">
                        <h2 class="flex flex-row items-center justify-between w-full title-container-menu">
                            {{ 'ORDER_DETAIL.MENU.DELIVERY_ROUTE' | translate }}
                        </h2>

                        @if (deliveryRoute) {
                            <div class="flex flex-row items-start justify-between w-full mb-5">
                                @if (deliveryRoute.finishedDate; as finishedDate) {
                                    <div class="flex flex-col w-full gap-1">
                                    <span class="font-typography-text-small-label text-neutral-default leading-[11px]">
                                        {{ 'ORDER_DETAIL.DELIVERY_ROUTE.FINISHED_DATE' | translate }}
                                    </span>
                                        <span class="font-typography-text-medium text-neutral-dark leading-[20px]">
                                        {{ finishedDate }}
                                    </span>
                                    </div>
                                } @else {
                                    <div class="flex flex-col w-full gap-1">
                                    <span class="font-typography-text-small-label text-neutral-default leading-[11px]">
                                        {{ 'ORDER_DETAIL.DELIVERY_ROUTE.EXPECTED_DATE' | translate }}
                                    </span>
                                        <span class="font-typography-text-medium text-neutral-dark leading-[20px]">
                                        {{ deliveryRoute.expectedDate }}
                                    </span>
                                    </div>
                                }
                            </div>
                            <div class="grid sm:grid-cols-2 gap-5 mb-5 w-full">
                                <div class="flex flex-col w-full gap-1">
                                <span class="font-typography-text-small-label text-neutral-default leading-[11px]">
                                    {{ 'ORDER_DETAIL.DELIVERY_ROUTE.PERIOD' | translate }}
                                </span>
                                    <span class="font-typography-text-medium text-neutral-dark leading-[20px]">
                                    {{ deliveryRoute.period }}
                                </span>
                                </div>
                            </div>

                            @if (!!deliveryRoute.trackingNumber) {
                                <div class="flex flex-col mb-5 w-full">
                                    <div class="flex flex-col w-full gap-1">
                                    <span class="font-typography-text-small-label text-neutral-default leading-[11px]">
                                        {{ 'ORDER_DETAIL.DELIVERY_ROUTE.TRACKING_NUMBER' | translate }}
                                    </span>
                                        <span class="font-typography-text-medium text-neutral-dark leading-[20px]">
                                        {{ deliveryRoute.trackingNumber }}
                                    </span>
                                    </div>
                                </div>
                            }

                            <div class="flex flex-col w-full">
                                <div class="flex flex-col w-full gap-1">
                                <span class="font-typography-text-small-label text-neutral-default leading-[11px]">
                                    {{ 'ORDER_DETAIL.DELIVERY_ROUTE.STATUS' | translate }}
                                </span>
                                    <div>
                                        <k-label [type]="deliveryRoute.status.type">
                                            {{ deliveryRoute.status.text }}
                                        </k-label>
                                    </div>
                                </div>
                            </div>
                        } @else {
                            <div class="flex flex-row items-start justify-between w-full mb-5">
                                <div class="flex flex-col w-full gap-1">
                                    <ngx-skeleton-loader [theme]="{ 'width.px': 100, 'height.px': 11 }" />
                                    <ngx-skeleton-loader [theme]="{ 'width.px': 128, 'height.px': 20 }" />
                                </div>
                            </div>
                            <div class="grid sm:grid-cols-2 gap-5 mb-5 w-full">
                                <div class="flex flex-col w-full gap-1">
                                    <ngx-skeleton-loader [theme]="{ 'width.px': 60, 'height.px': 11 }" />
                                    <ngx-skeleton-loader [theme]="{ 'width.px': 100, 'height.px': 20 }" />
                                </div>
                            </div>

                            <div class="flex flex-col mb-5 w-full">
                                <div class="flex flex-col w-full gap-1">
                                    <ngx-skeleton-loader [theme]="{ 'width.px': 130, 'height.px': 11 }" />
                                    <ngx-skeleton-loader [theme]="{ 'width.px': 160, 'height.px': 20 }" />
                                </div>
                            </div>

                            <div class="flex flex-col w-full">
                                <div class="flex flex-col w-full gap-1">
                                    <ngx-skeleton-loader [theme]="{ 'width.px': 60, 'height.px': 11 }" />
                                    <ngx-skeleton-loader [theme]="{ 'width.px': 73, 'height.px': 20, 'border-radius.px': 20 }" />
                                </div>
                            </div>
                        }
                    </div>
                }

                @if (!!order()?.table.rating) {
                    <div class="flex flex-col border-b-[1px] border-kiwid-divider p-6 gap-1">
                        <span class="font-typography-title-small text-brand-main-dark">{{ 'ORDER_DETAIL.MENU.RATING' | translate }}</span>

                        <div class="flex flex-row items-start justify-between mb-5 rating">
                            <div class="flex flex-row items-center cursor-pointer" (click)="openModalRating()">
                                <div class="flex flex-row items-center justify-start kw-stars-unit mr-2">
                                    @for (percentage of ratingStars(); track $index) {
                                        <div class="start-item">
                                        <span class="star-active" [style.width]="percentage">
                                            <mat-icon>star</mat-icon>
                                        </span>
                                            <span class="star-inactive">
                                            <mat-icon>star</mat-icon>
                                        </span>
                                        </div>
                                    }
                                </div>
                                <span>({{ ratingValue() }})</span>
                            </div>
                            @if (order()?.table.rating?.note) {
                                <mat-icon (click)="openModalRating()" class="cursor-pointer"> chat_bubble_outline</mat-icon>
                            }
                        </div>
                    </div>
                } @else if (order()?.table?.hasCreateRating) {
                    <div class="flex flex-col border-b-[1px] border-kiwid-divider p-6 gap-1">
                        <span class="font-typography-title-small text-brand-main-dark">{{ 'ORDER_DETAIL.MENU.RATING' | translate }}</span>

                        <div class="flex flex-row items-center justify-between mb-5 rating">
                            <div class="flex flex-row items-center justify-start cursor-pointer" (click)="openModalCreateRating()">
                                <mat-icon class="text-neutral-light">star</mat-icon>
                                <mat-icon class="text-neutral-light">star</mat-icon>
                                <mat-icon class="text-neutral-light">star</mat-icon>
                                <mat-icon class="text-neutral-light">star</mat-icon>
                                <mat-icon class="text-neutral-light">star</mat-icon>
                            </div>

                            <a (click)="openModalCreateRating()" class="cursor-pointer">
                                {{ 'ORDER_DETAIL.MENU.CREATE_RATING' | translate }}
                            </a>
                        </div>
                    </div>
                }
            </div>
        </div>
    </mat-drawer>

    <mat-drawer-content #matDrawerContent class="flex flex-col" [class.is-not-mobile]="!enableLayoutMobile()">
        <div class="flex flex-col container-data-tabs">
            <k-tab-bar
                #tabBar
                (tabEvent)="eventTab($event)"
                [items]="items()"
                [padding]="true"
                [tabActive]="getSelectedTabIndex()"
                style="max-width: 100vw"
                textTransform="initial"
            />
            @if (enableLayoutMobile()) {
                <div class="flex flex-row items-center justify-center toggle-layout-settings" (click)="toggleSidebar()">
                    <mat-icon svgIcon="kiwid:toggle" class="mr-3 text-white" />
                    {{ 'ORDER_DETAIL.TITLE' | translate }}
                </div>

                @if (hasPermissionChat()) {
                    <div class="flex flex-row items-center justify-center toggle-layout-settings" (click)="openChat()">
                        <mat-icon svgIcon="feather:message-square" class="mr-3 text-white" />
                        {{ 'ORDER_DETAIL.TABS.CHAT' | translate | uppercase }}
                    </div>
                }
            }
            <router-outlet />
        </div>
    </mat-drawer-content>
</mat-drawer-container>

<mat-menu
    #matMenuPatient="matMenu"
    [overlapTrigger]="false"
    class="bottom arrow-left fab-button mat-menu-employee"
    xPosition="after"
    yPosition="below"
>
    <ng-template matMenuContent>
        <div
            class="flex flex-col"
            fuseScrollReset
            (scroll)="onPatientScroll($event)"
            style="max-height: 300px; min-width: 250px; overflow: hidden; overflow-y: auto"
        >
            <div mat-menu-item style="min-height: 40px" (click)="$event.stopPropagation()">
                <span class="select-title-mat-menu">
                    {{ 'ORDER_DETAIL.MENU.PATIENT' | translate }}
                </span>
            </div>
            <form style="padding: 10px 16px" class="border-bottom-mat-menu mb-0" [formGroup]="formPatient()" (click)="$event.stopPropagation()">
                <k-form-input [formControl]="formPatientSearch()" [placeholder]="'ORDER_DETAIL.FORM.FIELDS.SEARCH' | translate">
                    <k-form-icon position="right">search</k-form-icon>
                </k-form-input>
            </form>
            @if (isLoadingPatient()) {
                <div class="flex flex-row items-center justify-center p-8">
                    <mat-progress-spinner color="accent" mode="indeterminate" diameter="25" strokeWidth="2" class="loader my-8" />
                </div>
            } @else {
                @if (renderPatientSelect().length === 0) {
                    <k-empty
                        class="m-8"
                        [size]="80"
                        [enablePadding]="false"
                        imageUrl="/assets/images/supplier/placeholder-empty.svg"
                        [description]="'ORDER_DETAIL.EMPTY_PATIENT' | translate"
                    />
                } @else {
                    @for (option of renderPatientSelect(); track option.id) {
                        <div
                            mat-menu-item
                            class="flex flex-row items-center justify-start overflow-hidden text-ellipsis"
                            (click)="setPatient(option.id)"
                        >
                            <span class="truncate">
                                {{ option.name }}
                            </span>
                        </div>
                    }
                    @if (isLoadingPatientFooter()) {
                        <div class="flex flex-row items-center justify-between p-2 footer-loader">
                            <mat-progress-spinner color="accent" mode="indeterminate" diameter="25" strokeWidth="2" class="loader" />
                        </div>
                    }
                }
            }
        </div>
    </ng-template>
</mat-menu>
